import { render } from "./StoryTags.vue?vue&type=template&id=18441eee&scoped=true"
import script from "./StoryTags.vue?vue&type=script&lang=js"
export * from "./StoryTags.vue?vue&type=script&lang=js"

import "./StoryTags.vue?vue&type=style&index=0&id=18441eee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-18441eee"

export default script